'use strict';

exports.sex = require('./filters/sex');
exports.hidden = require('./filters/hidden');
exports.getAgeFromIdCard = require('./filters/getAgeFromIdCard');
exports.ampm = require('./filters/ampm');
exports.week = require('./filters/week');
exports.timeFormat = require('./filters/timeFormat');
exports.getSexFromIdCard = require('./filters/getSexFromIdCard');
exports.str2time = require('./filters/str2time');
exports.mbSubstr = require('./filters/mbSubstr');